// Welche Google-Ziele gtag.js bei welcher Einwilligung bedienen darf.
//
// Noah 27.10.2026 (Nachtrag zu Datenstrategie D0b, PR #1142):
//   - Statistik erlaubt        -> gtag.js lädt, GA4 wird konfiguriert.
//   - Marketing erlaubt        -> gtag.js lädt, Google Ads (Conversions) wird konfiguriert.
//   - nur Marketing erlaubt    -> gtag.js lädt NUR für Google Ads: kein GA4-`config`,
//                                 analytics_storage bleibt denied, kein page_view an GA4.
//   - nichts erlaubt           -> gtag.js bleibt ungeladen, Befehle bleiben im dataLayer.
// Google Ads hängt ausschließlich an der Marketing-Einwilligung, GA4 ausschließlich an
// Statistik. Vorher wurde AW-… auch bei reiner Statistik-Einwilligung konfiguriert
// (cookielose Ads-Pings ohne Marketing-Einwilligung); das ist hiermit ebenfalls weg.
//
// Reine Funktionen ohne React und ohne DOM, damit sie testbar sind (googleTag.test.ts).

export const GA4_ID = "G-9CFJBN08VK";

export interface EinwilligungKurz {
  analytics?: boolean | null;
  marketing?: boolean | null;
}

export interface GoogleTagZiele {
  /** gtag.js überhaupt laden. */
  laden: boolean;
  /** GA4 konfigurieren und page_views an GA4 schicken. */
  ga4: boolean;
  /** Google Ads (AW-…) konfigurieren, Conversions senden. */
  ads: boolean;
}

export function googleTagZiele(e: EinwilligungKurz | null | undefined): GoogleTagZiele {
  const ga4 = e?.analytics === true;
  const ads = e?.marketing === true;
  return { laden: ga4 || ads, ga4, ads };
}

export type ConsentWert = "granted" | "denied";

export interface ConsentModeWerte {
  analytics_storage: ConsentWert;
  ad_storage: ConsentWert;
  ad_user_data: ConsentWert;
  ad_personalization: ConsentWert;
}

/** Werte für `gtag('consent', 'update', …)`. Nur ausdrückliches Ja gibt frei. */
export function consentModeWerte(e: EinwilligungKurz | null | undefined): ConsentModeWerte {
  const a: ConsentWert = e?.analytics === true ? "granted" : "denied";
  const m: ConsentWert = e?.marketing === true ? "granted" : "denied";
  return { analytics_storage: a, ad_storage: m, ad_user_data: m, ad_personalization: m };
}
